import Link from 'next/link'
import OriginPrice from './OriginPrice'
import SalePrice from './SalePrice'

interface PriceType {
  type?: string
  classes?: string
  classesSale?: string
  link?: string
  priceAtWarehouse?: boolean
  hasGift?: boolean
  originPrice: number
  finalPrice: number
}

export const Price = ({
  type,
  classes,
  classesSale,
  link = '',
  // priceAtWarehouse,
  // hasGift,
  originPrice,
  finalPrice,
}: PriceType) => {
  return (
    <Link
      href={link}
      className={`price-wrapper w-full mt-1 ${type ? type : ''}`}
    >
      <span className='sale-price flex items-center justify-between'>
        <SalePrice finalPrice={finalPrice} classes={classesSale} type={type} />
      </span>
      <OriginPrice originPrice={originPrice} classes={classes} type={type} />
    </Link>
  )
}

export default Price
